import systematic from '../../config/systematic';
import fetchApi from '../../utils/api/fetchApi';
import { defaultRtn, FileValidityPeriodStringType, RtnType } from '../../utilsTs/declareTypes';

/** 文件apis */
const filesApis = async () => { };

/** 文件上传选项 */
export declare interface UploadOptions {
    /** 服务地址，(服务地址、文件服务器id，二选一)，例如 http://localHost:3009/test/file/service */
    serverUrl?: string;
    /** 文件服务器id，(服务地址、文件服务器id，二选一) */
    filesServerId?: string;
    /** 服务id */
    serviceId: string;
    /** 文件组id */
    filesGroupId: string;
    /** 文件存的子目录 */
    subdirectory?: string;
    /** 文件有效期id，默认：permanent */
    fileValidityPeriodId?: FileValidityPeriodStringType;
    /** 扩展数据 */
    extendedData?: Record<string, string | number | boolean>;
    /** 文件上传后的回调方法，返回格式RtnType: { success: boolean, data: any } */
    callback?: (result: RtnType<any>) => void;
};

/** 文件上传返回 */
export declare interface UploadReturn {
    /** 服务id */
    serviceId: string;
    /** 上传配置 */
    config: any;
};

/**
 * 文件上传
 * @param options 选项
 * @returns 
 */
filesApis.upload = async (options: UploadOptions): Promise<RtnType<UploadReturn>> => {
    const rtn = defaultRtn<UploadReturn>();
    try {
        let { serverUrl, filesServerId, serviceId, filesGroupId,
            subdirectory, extendedData, callback, fileValidityPeriodId = 'permanent' } = options;
        if (typeof serverUrl === 'undefined') {
            if (filesServerId) {
                //获取上传服务地址
                /** 后端数据defaultService */
                const defaultService: any = systematic.wmService;
                const fethcRes = await fetchApi.GET(defaultService,
                    {
                        apiId: 'filesServer',
                        apiExtend: 'getDefaultServer',
                        apiVariable: filesServerId,
                        apiData: {
                            urlModel: 'apiServiceUrl'
                        }
                    });
                if (fethcRes.success === true) {
                    serverUrl = fethcRes.data;
                }
            }
        }
        /** 上传配置 */
        const config = {
            name: 'file',
            action: serverUrl,
            headers: {
                authorization: `Bearer ${localStorage.getItem('token') as string}`,
                apiId: 'files',
                apiExtend: 'uploadSingleFile',
                filesGroupId,
                subdirectory,
                serviceId,
                fileValidityPeriodId,
                ...extendedData
            },
            async onChange(info: any) {
                if (info.file.status !== 'uploading') {
                }
                if (info.file.status === 'done') {
                    if (info.file.response.success) {
                        if (callback) {
                            callback(
                                {
                                    success: true,
                                    data: {
                                        upload: info.file.response.data,
                                        filesGroupId
                                    }
                                }
                            );
                        }
                    }
                    else {
                        if (callback) {
                            callback({
                                success: false,
                                message: info.file.response.message
                            })
                        }
                    }
                } else if (info.file.status === 'error') {
                    if (callback) {
                        callback({
                            success: false,
                            message: info.file.response.message
                        })
                    }
                }
            },
        }
        rtn.success = true;
        rtn.data = {
            serviceId,
            config
        };
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `${rtn.message}${message}`;
        }
    }
    return rtn;
};

/** 文件apis */
export default filesApis;